import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const QuestionLabel = ({ children }) => {
	const { t } = useTranslation();

	return (
		<p className='text-xs font-medium leading-[1.2] text-on-secondary uppercase'>
			{t('result_page.your_question')}
			{children}
		</p>
	);
};

QuestionLabel.propTypes = {
	children: PropTypes.node,
};

export default QuestionLabel;
